import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '', subject: '', message: ''
  });
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      setStatus(data);
      if (data.success) {
        setFormData({ name: '', email: '', phone: '', company: '', subject: '', message: '' });
      }
    } catch {
      setStatus({ success: false, message: 'Bağlantı hatası. Lütfen tekrar deneyin.' });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1>İletişim</h1>
          <p>İşinize yardımcı olmak için buradayız. Bizimle iletişime geçin.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-form">
              <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '8px' }}>Bize Yazın</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '28px' }}>
                Formu doldurun, en kısa sürede size dönüş yapalım.
              </p>

              {status && (
                <div style={{
                  padding: '14px 20px',
                  borderRadius: 'var(--radius-md)',
                  marginBottom: '20px',
                  background: status.success ? 'rgba(0, 230, 138, 0.1)' : 'rgba(255, 107, 53, 0.1)',
                  border: `1px solid ${status.success ? 'rgba(0, 230, 138, 0.3)' : 'rgba(255, 107, 53, 0.3)'}`,
                  color: status.success ? 'var(--accent-green)' : 'var(--accent-orange)',
                  fontSize: '0.85rem'
                }}>
                  {status.message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group">
                    <label>Ad Soyad *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Adınız Soyadınız" />
                  </div>
                  <div className="form-group">
                    <label>E-posta *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="ornek@firma.com" />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group">
                    <label>Telefon</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+90 5XX XXX XXXX" />
                  </div>
                  <div className="form-group">
                    <label>Firma</label>
                    <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Firma Adı" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Konu</label>
                  <select name="subject" value={formData.subject} onChange={handleChange}>
                    <option value="">Konu Seçin</option>
                    <option value="bulut">Bulut Hizmetleri</option>
                    <option value="guvenlik">Siber Güvenlik</option>
                    <option value="network">Network Çözümleri</option>
                    <option value="veri-merkezi">Veri Merkezi</option>
                    <option value="danismanlik">Danışmanlık</option>
                    <option value="diger">Diğer</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Mesajınız *</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} required placeholder="İhtiyaçlarınızı ve projelerinizi kısaca açıklayın..." />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                  Gönder →
                </button>
              </form>
            </div>

            <div className="contact-info-cards">
              <div className="contact-info-card">
                <div className="card-icon">✉️</div>
                <div>
                  <h4>E-posta</h4>
                  <p>info@emurinnovation.com<br />destek@emurinnovation.com</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="card-icon">🕐</div>
                <div>
                  <h4>Çalışma Saatleri</h4>
                  <p>Pazartesi - Cuma: 09:00 - 18:00<br />Teknik Destek: 7/24</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="card-icon">🎫</div>
                <div>
                  <h4>Destek Merkezi</h4>
                  <p>destek@emurinnovation.com<br />7x24 Ticket Sistemi</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="card-icon">🌐</div>
                <div>
                  <h4>Sosyal Medya</h4>
                  <p>LinkedIn | Twitter | Instagram<br />YouTube</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
